/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_EndedInputs */

const th_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จบแล้ว`)
};

const en_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

const ja_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

const zh_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已结束`)
};

const es_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizada`)
};

const pt_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrada`)
};

const id_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berakhir`)
};

const fr_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminée`)
};

const tl_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapos na`)
};

const vi_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết thúc`)
};

const ko_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종료됨`)
};

const de_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet`)
};

const ru_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершено`)
};

const tr_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitti`)
};

const it_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminata`)
};

const pl_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakończono`)
};

const uk_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершено`)
};

const hi_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्त`)
};

const ar_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهى`)
};

const ms_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamat`)
};

const bn_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শেষ`)
};

const zh_tw2_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

const zh_hk2_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

const ur_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ختم`)
};

const fa_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پایان‌یافته`)
};

const sw_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umeisha`)
};

const nl_video_ended = /** @type {(inputs: Video_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgelopen`)
};

/**
* | output |
* | --- |
* | "Ended" |
*
* @param {Video_EndedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_ended = /** @type {((inputs?: Video_EndedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_EndedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_ended(inputs)
	if (locale === "ja") return ja_video_ended(inputs)
	if (locale === "zh") return zh_video_ended(inputs)
	if (locale === "es") return es_video_ended(inputs)
	if (locale === "pt") return pt_video_ended(inputs)
	if (locale === "id") return id_video_ended(inputs)
	if (locale === "fr") return fr_video_ended(inputs)
	if (locale === "tl") return tl_video_ended(inputs)
	if (locale === "vi") return vi_video_ended(inputs)
	if (locale === "ko") return ko_video_ended(inputs)
	if (locale === "de") return de_video_ended(inputs)
	if (locale === "ru") return ru_video_ended(inputs)
	if (locale === "tr") return tr_video_ended(inputs)
	if (locale === "it") return it_video_ended(inputs)
	if (locale === "pl") return pl_video_ended(inputs)
	if (locale === "uk") return uk_video_ended(inputs)
	if (locale === "hi") return hi_video_ended(inputs)
	if (locale === "ar") return ar_video_ended(inputs)
	if (locale === "ms") return ms_video_ended(inputs)
	if (locale === "bn") return bn_video_ended(inputs)
	if (locale === "zh-TW") return zh_tw2_video_ended(inputs)
	if (locale === "zh-HK") return zh_hk2_video_ended(inputs)
	if (locale === "ur") return ur_video_ended(inputs)
	if (locale === "fa") return fa_video_ended(inputs)
	if (locale === "sw") return sw_video_ended(inputs)
	if (locale === "nl") return nl_video_ended(inputs)
	return en_video_ended(inputs)
});